import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/bonus/tab_select.png'
import _imports_1 from '@/assets/bonus/tab_default.png'
import _imports_2 from '@/assets/bonus/select.png'
import _imports_3 from '@/assets/bonus/gray_select.png'
import _imports_4 from '@/assets/bonus/tab_arrow.png'
import _imports_5 from '@/assets/bonus/smactv2_reg_time.png'
import _imports_6 from '@/assets/bonus/smactv2_amount.png'
import _imports_7 from '@/assets/bonus/smactv2_clock.png'
import _imports_8 from '@/assets/bonus/smactv2_misterioso.png'
import _imports_9 from '@/assets/bonus/weikaishi_tu.png'
import _imports_10 from '@/assets/bonus/smactv2_btn_expire.png'
import _imports_11 from '@/assets/bonus/smactv2_btn_notstart.png'


const _hoisted_1 = { class: "bonus_container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "day_row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "day_card" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_8 = { class: "content" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "select_icon"
}
const _hoisted_11 = {
  key: 1,
  class: "select_icon"
}
const _hoisted_12 = {
  key: 2,
  class: "select_icon"
}
const _hoisted_13 = {
  key: 0,
  class: "tab_arrow"
}
const _hoisted_14 = { style: {"padding":"15px 25px"} }
const _hoisted_15 = {
  key: 0,
  class: "details_card"
}
const _hoisted_16 = { class: "date_details" }
const _hoisted_17 = {
  key: 0,
  class: "tabel_container"
}
const _hoisted_18 = { style: {"color":"#FFEE00","font-size":"14px"} }
const _hoisted_19 = {
  key: 1,
  class: "bottom_text"
}

import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { ref } from 'vue';
import { BonusData, calculateValue, MYSTERIO_IMG } from '@/view/bonus/supportScript';
import CustomHeader from '../components/common/customHeader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusView',
  props: {
    dataSet: {}
  },
  emits: ['pickMisteryGift', 'selectTab'],
  setup(__props: any, { emit: __emit }) {

const mysterioImages = ref(MYSTERIO_IMG)

const props = __props

const emits = __emit

const pickMisteryGift = (activeStatus: number) => {
   emits('pickMisteryGift',activeStatus)
}

const selectTab = (item: any) => {
    emits('selectTab', item)
}


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('bonus.mysterybonus')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.dataSet.bannerIcon,
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.dayList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (selectTab(item))
          }, [
            _createElementVNode("div", _hoisted_5, [
              (item.reward_day == _ctx.dataSet.selectedTab.reward_day)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: mysterioImages.value[index].img,
                  alt: "",
                  width: "50%"
                }, null, 8, _hoisted_9),
                _createElementVNode("div", {
                  class: "date_text",
                  style: _normalizeStyle({ color: item.reward_day == _ctx.dataSet.selectedTab.reward_day ? '#FFEE00' : '' })
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.travel')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(item.reward_day), 1)
                ], 4),
                (item.reward_data?.rewardCoin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[1] || (_cache[1] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: ""
                      }, null, -1)
                    ])))
                  : (item.reward_data?.activeStatus === 0 && !item.reward_data?.rewardCoin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_van_icon, {
                          name: "checked",
                          size: "18",
                          style: {"background":"#d4d4d4","border-radius":"30px","padding":"0.1px"},
                          color: "red"
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[2] || (_cache[2] = [
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: ""
                        }, null, -1)
                      ])))
              ])
            ]),
            (item.reward_day == _ctx.dataSet.selectedTab.reward_day)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_4,
                    alt: ""
                  }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.dataSet.selectedTab)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_van_row, { class: "details_content" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, { span: "2" }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("img", {
                      src: _imports_5,
                      alt: ""
                    }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "label_text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('bonus.registrationTime')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "10",
                  class: "value_text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(formatUnixTimestamp)(_ctx.dataSet.mysteryDataConfig?.config?.user_join_date)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, { span: "2" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("img", {
                      src: _imports_6,
                      alt: ""
                    }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "label_text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('bonus.totalDeposit')) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.dataSet.selectedTab?.reward_day), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.days')) + ":", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "10",
                  class: "value_text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("R$" + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rechargeCoin || 0)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, { span: "24" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_row, { class: "middleCard" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "24",
                          class: "text_1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('bonus.claimTime')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_col, { span: "24" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[6] || (_cache[6] = _createElementVNode("img", {
                                src: _imports_7,
                                alt: ""
                              }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(formatUnixTimestamp)(_ctx.dataSet.selectedTab?.reward_data?.rewardTime)), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0)
                          ? (_openBlock(), _createBlock(_component_van_col, {
                              key: 0,
                              span: "24",
                              class: "misterio_text"
                            }, {
                              default: _withCtx(() => [
                                _cache[7] || (_cache[7] = _createElementVNode("img", {
                                  src: _imports_8,
                                  alt: ""
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('bonus.mysterybonus')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 || _ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                          ? (_openBlock(), _createBlock(_component_van_col, {
                              key: 1,
                              span: "24",
                              class: "amount"
                            }, {
                              default: _withCtx(() => [
                                _cache[8] || (_cache[8] = _createTextVNode("R$ ")),
                                _createElementVNode("span", {
                                  style: _normalizeStyle({ color: _ctx.dataSet.selectedTab?.reward_data?.rewardCoin > 0 ? '#993900' : '' })
                                }, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rewardCoin || 0)), 5)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 2 ||  (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin))
                          ? (_openBlock(), _createBlock(_component_van_col, {
                              key: 2,
                              span: "24",
                              class: "misterio"
                            }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("img", {
                                  src: _imports_9,
                                  alt: ""
                                }, null, -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 0,
                      span: "24",
                      class: "start_img"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createElementVNode("img", {
                          src: _imports_10,
                          alt: ""
                        }, null, -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 1,
                      span: "24",
                      class: "statusBar",
                      style: {"color":"#66d329"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 2,
                      span: "24",
                      class: "start_img2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _imports_11,
                          alt: "",
                          class: _normalizeClass({ 'pop-animate': _ctx.dataSet.isPopping }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (pickMisteryGift(_ctx.dataSet.selectedTab?.reward_data?.activeStatus)))
                        }, null, 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 3,
                      span: "24",
                      class: "statusBar",
                      style: {"color":"#66d329"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 2)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 4,
                      span: "24",
                      class: "statusBar",
                      style: {"color":"#f8d8a7"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('rewards.notActivated')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.dataSet.selectedTab)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_van_row, { class: "tabel_hed" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "11",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('bonus.depostiScope')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "2",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createElementVNode("div", { class: "line" }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "11",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('bonus.mysterybonus')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.selectedTab?.reward_data?.reward_day_data, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              class: "tabel_row",
              key: index,
              style: _normalizeStyle({
                backgroundColor: index % 2 === 1 ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
                borderTop: index % 2 === 1 ? '1px solid rgba(255, 255, 255, 0.15)' : 'none'
            })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _cache[12] || (_cache[12] = _createTextVNode("R$ ")),
                    _createElementVNode("span", null, _toDisplayString(item.recharge_min < 0 ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.recharge_min))) + " ~ " + _toDisplayString(item.recharge_max < 0 ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.recharge_max))), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _cache[13] || (_cache[13] = _createTextVNode("R$ ")),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.show_reward_min < 0 ? '\u221E'
                    : _unref(formatCurrency)(_unref(calculateValue)(item.show_reward_min))) + " ~ " + _toDisplayString(item.show_reward_max < 0 ? '\u221E' :
                            _unref(formatCurrency)(_unref(calculateValue)(item.show_reward_max))), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["style"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.dataSet.activityInfo.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "6",
                class: ""
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("div", { class: "line1" }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "12",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "6",
                class: ""
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createElementVNode("div", { class: "line2" }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})